// פונקציות לשימוש פנימי של הקליינט או Redux Thunk

import { animeDBService } from '../services/AnimeDB/animeDB.service.remote'

/**
 * 🔎 שליפת רשימת אנימות עם פילטרים
 */
export async function loadAnimes(filterBy = {}) {
  try {
    const animes = await animeDBService.query(filterBy)
    return animes
  } catch (err) {
    console.error('❌ [animeDB.controller] loadAnimes error:', err)
    throw err
  }
}

/**
 * 🔎 שליפת אנימה בודדת לפי MAL ID
 */
export async function loadAnimeById(id) {
  try {
    const anime = await animeDBService.getById(id)
    return anime
  } catch (err) {
    console.error(`❌ [animeDB.controller] loadAnimeById(${id}) error:`, err)
    throw err
  }
}

/**
 * 💾 שמירה או עדכון אנימה
 */
export async function saveAnime(anime) {
  try {
    const savedAnime = await animeDBService.save(anime)
    return savedAnime
  } catch (err) {
    console.error('❌ [animeDB.controller] saveAnime error:', err)
    throw err
  }
}

/**
 * 🗑️ מחיקת אנימה
 */
export async function removeAnime(id) {
  try {
    const removedId = await animeDBService.remove(id)
    return removedId
  } catch (err) {
    console.error(`❌ [animeDB.controller] removeAnime(${id}) error:`, err)
    throw err
  }
}

/**
 * 🔎 שליפת רשימת אנימות לפי מזהים
 * @param {Array} ids - מערך מזהים (מספרים או ObjectId)
 * @param {boolean} full - האם להביא מידע מלא (default=false)
 */
export async function loadAnimesByIds(ids = [], full = false) {
  try {
    const animes = await animeDBService.getByIds(ids, full)
    return animes
  } catch (err) {
    console.error('❌ [animeDB.controller] loadAnimesByIds error:', err)
    throw err
  }
}
